module.exports = __webpack_public_path__ + "static/status_ticket_succ.79cceea9.png";